export const stripHTML = (value) => {
	const div = document.createElement('div')
	div.innerHTML = value
	return div.textContent || div.innerText || ''
}
